export default function deleteCookie(cname){
    // 依網址判斷附加後綴
    let urlAppend = ''
    let secureAppend = ';secure=true'
    let domainAppend = ';domain=.cathaylife.com.tw'
    if(window.location.href.indexOf('localhost') !== -1){
        urlAppend = ''
        secureAppend = ''
        domainAppend = ''
    }else if(window.location.href.indexOf('tmycrm') !== -1){
        urlAppend = '.T'
    }else if(window.location.href.indexOf('smycrm') !== -1){
        urlAppend = '.S'
    }else if (window.location.href.indexOf('mycrm') !== -1) {
        // do nothing
    }else{
        secureAppend = ''
        domainAppend = ''
    }
    var name = cname + urlAppend;
    document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/" + domainAppend + secureAppend
}